import AuthorityEnum from './authority.enum';

export default class Authority {
  private authorities: string[];

  constructor(authorities: string[]) {
    this.authorities = authorities;
  }

  hasAuthorities(match: string[]): boolean {
    if (this.authorities && match) {
      const result = this.authorities.find(value => match.includes(value));
      return (result && result.length > 0) || false;
    }
    return false;
  }

  isAdministrator(): boolean {
    return this.hasAuthorities([AuthorityEnum.ADMINISTRATOR]);
  }

  isManager(): boolean {
    return this.hasAuthorities([AuthorityEnum.MANAGER]);
  }
}
